const { useContext } = require("react");
const { AuthContext } = require("src/store/provider/AuthProvider");

export const useAuth = () => {
  return useContext(AuthContext);
};
